webpackJsonp([142629428675168],{

/***/ 470:
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"allMarkdownRemark": {
				"edges": [
					{
						"node": {
							"fields": {
								"slug": "/custom-animations"
							},
							"frontmatter": {
								"order": 4,
								"title": "Custom Animations",
								"image": "https://res.cloudinary.com/ericwindmill/image/upload/v1526135592/custom_loader_gif_qpsmjq.gif",
								"description": "",
								"exampleUrl": "/step-one-tweening",
								"type": "example"
							},
							"html": "<ul>\n<li>Animations</li>\n<li>AnimatedWidget</li>\n<li>Transform</li>\n<li>TickerProviderStateMixin</li>\n<li>Tweens</li>\n</ul>"
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/build-a-basic-flutter-app"
							},
							"frontmatter": {
								"order": 1,
								"title": "Build a Basic Flutter App",
								"image": "http://res.cloudinary.com/ericwindmill/image/upload/c_scale,h_500/v1521385459/flutter_by_example/Simulator_Screen_Shot_-_iPhone_X_-_2018-03-10_at_10.27.34.png",
								"description": "",
								"exampleUrl": "/basic-dogs-app-setup",
								"type": "example"
							},
							"html": "<ul>\n<li>Layout</li>\n<li>Routes</li>\n<li>HTTP</li>\n<li>Forms</li>\n<li>Hero Animations</li>\n<li>Fade In Images</li>\n<li>Gradients</li>\n<li>Sliders</li>\n<li>Alert Dialogs</li>\n</ul>"
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/google-static-maps"
							},
							"frontmatter": {
								"order": 6,
								"title": "Google Static Maps",
								"image": "http://res.cloudinary.com/ericwindmill/image/upload/v1512320238/flutter-static-maps/Simulator_Screen_Shot_-_iPhone_6_-_2017-12-03_at_08.56.53.png",
								"description": "",
								"exampleUrl": "",
								"type": "example"
							},
							"html": "<ul>\n<li>Google Static Maps API</li>\n<li>Device Location</li>\n<li>HTTP</li>\n<li>Dart Streams</li>\n<li>Basic UI</li>\n<li>Buttons</li>\n</ul>"
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/architecture-auth-with-firebase-inherited-widget"
							},
							"frontmatter": {
								"order": 3,
								"title": "Architecture: Auth with Firebase + Inherited Widget",
								"image": "https://res.cloudinary.com/ericwindmill/image/upload/v1525792616/inherited_auth_kw4kea.gif",
								"description": "",
								"exampleUrl": "/state-management-the-flutter-way",
								"type": "example"
							},
							"html": "<ul>\n<li>InheritedWidget</li>\n<li>State Management</li>\n<li>Firebase Integration</li>\n<li>Firebase Google OAuth</li>\n<li>Routing</li>\n<li>Loading Screens</li>\n</ul>"
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/architecture-auth-with-redux-firebase"
							},
							"frontmatter": {
								"order": 2,
								"title": "Architecture: Auth with Redux + Firebase",
								"image": "https://res.cloudinary.com/ericwindmill/image/upload/v1525792547/redux_auth_tyjro2.gif",
								"description": "",
								"exampleUrl": "/redux-app-getting-to-start",
								"type": "example"
							},
							"html": "<ul>\n<li>Flutter Redux package</li>\n<li>State Management</li>\n<li>Firebase Integration</li>\n<li>Firebase Google Auth</li>\n<li>Linear Gradients</li>\n</ul>"
						}
					},
					{
						"node": {
							"fields": {
								"slug": "/night-sky-animation"
							},
							"frontmatter": {
								"order": 5,
								"title": "Night Sky Animation",
								"image": "https://res.cloudinary.com/ericwindmill/image/upload/v1526854373/flutter_star_animation_hetibt.gif",
								"description": "",
								"exampleUrl": "https://github.com/ericwindmill/flutter_by_example_apps/tree/master/stars_animation",
								"type": "example"
							},
							"html": "<p><a href=\"https://github.com/ericwindmill/flutter_by_example_apps/tree/master/stars_animation\">This tutorial isn't done, but you can find the source code here.</a></p>\n<ul>\n<li>Animation Controller</li>\n<li>Gradients</li>\n<li>BoxShape</li>\n<li>Tweens</li>\n<li>Stacks (lots of stacks)</li>\n<li>Reusable Animations</li>\n</ul>"
						}
					}
				]
			}
		},
		"pathContext": {}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---index-9280437c29d942c0dee5.js